import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
} from "@material-ui/core";
import "./case-preview.component.scoped.scss";
import { UserAnswer } from "../../types/ai-question";
import { AiQuestion } from "../../types/ai-question";
import CasePreivewContentComponent from "./case-preview-content/case-preview-content.component";
import { ROLES } from "../../modules/case/types/AI-roles";

interface CasePreviewModalProps {
  open: boolean;
  onClose: () => void;
  userAnswers: UserAnswer[];
  questions: AiQuestion[];
  role: ROLES | ""
}

const CasePreviewModal: React.FC<CasePreviewModalProps> = ({
  open,
  onClose,
  userAnswers,
  questions,
  role
}) => {
  const [useCaseDetails, setUseCaseDetails] = useState<any>({});

  // Helper to get display value for select answers
  // const getDisplayAnswer = (answer: UserAnswer) => {
  //   if (answer.type === "select") {
  //     const question = questions.find(q => q.id === answer.questionId);
  //     if (!question || !question.options) return answer.answer;
  //     if (Array.isArray(answer.answer)) {
  //       // Multiple choice
  //       const names = answer.answer
  //         .map((id) => question.options?.find((opt) => opt.id === id)?.name)
  //         .filter(Boolean);
  //       return names.join(", ");
  //     } else {
  //       // Single select
  //       return question.options.find((opt) => opt.id === answer.answer)?.name || answer.answer;
  //     }
  //   }
  //   // Default: show answer as-is
  //   return answer.answer;
  // };


  const handlePreview = () => {
    const userAnswersPreview = questions.map((q: any) => {
      const match = userAnswers.find((a: any) => a.questionId === q.id);
      if (!match) return null;
      let value;
      if (!q.options) { value = match.answer }
      if (Array.isArray(match.answer)) {
        value = match.answer
          .map((id) => q.options?.find((opt: any) => opt.id === id))
          .filter(Boolean);
      } else {
        console.log(q);
        value = match.answer
      }
      return {
        key: q.field.key,
        answer: value
      };
    })
    const result = userAnswersPreview.reduce((acc: any, item: any) => {
      acc[item.key] = item.answer;
      return acc;
    }, {});
    result.role = role;
    result.major = 0;
    result.minor = 0;
    result.version = 1;
    result.users = JSON.parse(result.users);
    setUseCaseDetails(result);
  }

  useEffect(() => {
    handlePreview();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogContent style={{ padding: "0 !important" }}>
        <CasePreivewContentComponent caseDetails={useCaseDetails} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CasePreviewModal; 